export const LocalConfigs = {
    API_URL: window._env_.API_URL,
    APP_URL: window._env_.APP_URL
};
